/**
 * AI Insights marketplace tool (issue #189).
 *
 * The whole AI-driven clinical intelligence surface — session analysis,
 * recommendations, therapeutic-plan analysis, clinical alerts and live insights —
 * is gated behind adoption of this tool.
 */
export const AI_INSIGHTS_TOOL_SLUG = "ai-insights";

export interface AiInsightsAdoption {
    /** True only when the tool is confirmed adopted; failures resolve to false. */
    adopted: boolean;
    loading: boolean;
}

export interface LockedStateProps {
    /** Panel heading, e.g. the surface being locked. */
    title: string;
    /** Short explanation of why the panel is locked. */
    description?: string;
    className?: string;
    /** Renders a compact variant for in-session/side panels. */
    compact?: boolean;
}
